<template>
  <div class="header">
    <Logo></Logo>
    <div class="header-main">
    </div>
  </div>
</template>
<script>
import Logo from "../Logo/fullLogo.vue";
import UserOneIDAuth from "../UserOneIDAuth/index.vue";

export default {
  components: {
    Logo,
    UserOneIDAuth,
  },
  data() {
    return {
      // 隐藏logo的route name
      logoHiddenRoutes: ["home"],
      // dark模式的route name
      darkStyleRoutes: ["home"],
      // 跳转至外部的route name
      alinkRoutes: ["about", "github", "endpoint"],
      showroute: false,
      tabBar: [
        {
          value: "home",
          name: "Home",
        },
        // {
        //   value: "recommend",
        //   name: "Data Recommendation",
        // },
      ],
    };
  },
  methods: {
    handleshowroute() {
      this.showroute = true;
    },
    handlecloseroute() {
      this.showroute = false;
    },
  },
};
</script>
<style lang="less" scoped>
* {
  font-family: ddefont;
}
.header {
  height: 64px;
  min-width: 1080px;
  // background: linear-gradient(116.69deg, #000 -86.16%, #00a2ff 56.2%);
  // background: #1f1f1f;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  color: #fff;
  z-index: 999;
  position: relative;
  // overflow: hidden;

  .layout-right {
    display: flex;
    align-items: center;
    margin-right: 15px;
    a {
      font-size: 18px !important;
    }
  }
  .title {
    font-family: Source Han Sans SC;
    font-weight: 900;
    font-size: 28px;
    margin-left: 16px;
    vertical-align: bottom;
  }
  .link {
    margin-left: 36px;
    cursor: pointer;
    line-height: 36px;
  }
  .highlight {
    font-weight: 900;
    border-bottom: 2px solid white;
  }
  .hidden-logo {
    visibility: hidden;
  }
  .link a,
  .router-link-active {
    color: inherit;
    text-decoration: none;
  }

  .layout-right {
    display: flex;
    align-items: center;
    margin-right: 15px;
    a {
      font-size: 18px !important;
    }
  }
  .title {
    font-family: Source Han Sans SC;
    font-weight: 900;
    font-size: 28px;
    margin-left: 16px;
    vertical-align: bottom;
  }
  .link {
    margin-left: 36px;
    cursor: pointer;
    line-height: 36px;
  }
  .highlight {
    font-weight: 900;
    border-bottom: 2px solid white;
  }
  .hidden-logo {
    visibility: hidden;
  }
  .link a,
  .router-link-active {
    color: inherit;
    text-decoration: none;
  }
}
.dark-style {
  color: #000;
  background: transparent;
}
.header-main {
  position: absolute;
  top: 15px;
  left: 0;
  width: 100%;
}
.header-text {
  width: 1100px;
  margin: 0 auto;
}
.route-wrap {
  font-family: Source Han Sans SC;
  font-size: 20px;
  margin-left: 16px;
  font-weight: bold;
  vertical-align: bottom;
  line-height: 64px;
  cursor: pointer;
  position: relative;
}
#rs {
  span {
    display: block;
    line-height: 30px;
    padding: 0 10px;
    a {
      font-size: 16px !important;
      color: black !important;
      text-decoration: none !important;
    }
  }
  span:hover {
    background-color: rgb(135, 183, 246);
    a {
      color: white !important;
    }
  }
}
.route-show {
  position: absolute;
  width: 240px;
  top: 64px;
  left: -50px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 1px 1px 3px 3px #e1e1e1;
  padding: 10px 0;
  color: black;
  font-size: 16px;
  font-weight: 500;
  span {
    display: block;
    line-height: 30px;
    padding: 0 10px;
    a {
      font-size: 16px !important;
      color: black !important;
      text-decoration: none !important;
    }
  }
  span:hover {
    background-color: rgb(135, 183, 246);
    a {
      color: white !important;
    }
  }
}
</style>